/**
 * Pawkraft Kit Ordering Flow
 * Configure -> Checkout. Photos are uploaded after purchase via email link.
 */
(function () {
  'use strict';

  var state = {
    kit: 'single',
    pet1Name: '', pet1Breed: '', pet1Sex: '', pet1Pose: 'standing',
    pet2Name: '', pet2Breed: '', pet2Sex: '', pet2Pose: 'standing', pet2SamePet: true,
    photos: { pet1: [], pet2: [] },
    photosDeferred: false,
    currentStep: 1
  };

  var flowConfig = {};
  var PRICE_LABELS = { single: '$' + '99', duo: '$' + '159' };
  var MIN_PHOTOS = 6;
  var MAX_PHOTOS = 10;
  // Keep browser uploads below Vercel's function body ceiling.
  var TARGET_UPLOAD_BYTES = Math.floor(3.75 * 1024 * 1024);
  var MAX_UPLOAD_DIMENSION = 3000;
  var LS_KEY = 'pawkraft_flow_state';
  var STATE_VERSION = 3;
  var CHECKOUT_STARTED_KEY = 'pawkraft_flow_checkout_started';
  var SAVED_STATE_MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;
  var sessionIds = { pet1: null, pet2: null };
  var uploadApiUrl = '';
  var manualMode = false;
  var manualRequiredPets = [1];
  var manualSubmitted = false;

  // --- Pose SVGs ---
  var POSE_SVGS = {
    sitting: '<svg viewBox="0 0 240 240" fill="none" stroke="#6B8F71" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><ellipse cx="120" cy="155" rx="50" ry="35"/><circle cx="120" cy="90" r="32"/><path d="M95 68c-6-18-2-32 8-34s16 10 14 24"/><path d="M145 68c6-18 2-32-8-34s-16 10-14 24"/><circle cx="108" cy="86" r="4" fill="#2C2C28" stroke="none"/><circle cx="132" cy="86" r="4" fill="#2C2C28" stroke="none"/><ellipse cx="120" cy="98" rx="5" ry="3.5" fill="#2C2C28" stroke="none"/><path d="M100 180v28M140 180v28"/><path d="M168 148c12-4 22-14 18-28"/></svg>',
    standing: '<svg viewBox="0 0 240 240" fill="none" stroke="#6B8F71" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><ellipse cx="120" cy="120" rx="48" ry="30"/><circle cx="120" cy="65" r="30"/><path d="M97 45c-5-16-1-28 7-30s14 9 12 22"/><path d="M143 45c5-16 1-28-7-30s-14 9-12 22"/><circle cx="109" cy="61" r="3.5" fill="#2C2C28" stroke="none"/><circle cx="131" cy="61" r="3.5" fill="#2C2C28" stroke="none"/><ellipse cx="120" cy="72" rx="4.5" ry="3" fill="#2C2C28" stroke="none"/><path d="M88 145v52M112 145v52M128 145v52M152 145v52"/><path d="M166 115c10-3 18-12 15-24"/></svg>',
    'lying-down': '<svg viewBox="0 0 240 240" fill="none" stroke="#6B8F71" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><ellipse cx="130" cy="145" rx="70" ry="25"/><circle cx="65" cy="115" r="28"/><path d="M44 97c-5-15-1-26 6-28s13 8 11 20"/><path d="M86 97c5-15 1-26-6-28s-13 8-11 20"/><circle cx="55" cy="111" r="3.5" fill="#2C2C28" stroke="none"/><circle cx="75" cy="111" r="3.5" fill="#2C2C28" stroke="none"/><ellipse cx="65" cy="122" rx="4" ry="3" fill="#2C2C28" stroke="none"/><path d="M75 165v16M185 165v16"/><path d="M198 140c8-2 14-10 12-20"/></svg>',
    walking: '<svg viewBox="0 0 240 240" fill="none" stroke="#6B8F71" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><ellipse cx="115" cy="120" rx="50" ry="28"/><circle cx="80" cy="72" r="28"/><path d="M59 54c-5-15-1-26 6-28s13 8 11 20"/><path d="M101 54c5-15 1-26-6-28s-13 8-11 20"/><circle cx="70" cy="68" r="3.5" fill="#2C2C28" stroke="none"/><circle cx="90" cy="68" r="3.5" fill="#2C2C28" stroke="none"/><ellipse cx="80" cy="79" rx="4" ry="3" fill="#2C2C28" stroke="none"/><path d="M82 144l-16 52M102 144l8 52M132 144l14 50M152 142l-6 54"/><path d="M163 114c10-3 18-12 15-24"/></svg>',
    playing: '<svg viewBox="0 0 240 240" fill="none" stroke="#6B8F71" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><ellipse cx="110" cy="130" rx="48" ry="30" transform="rotate(-10 110 130)"/><circle cx="90" cy="78" r="28"/><path d="M69 60c-5-15-1-26 6-28s13 8 11 20"/><path d="M111 60c5-15 1-26-6-28s-13 8-11 20"/><circle cx="80" cy="74" r="3.5" fill="#2C2C28" stroke="none"/><circle cx="100" cy="74" r="3.5" fill="#2C2C28" stroke="none"/><ellipse cx="90" cy="85" rx="4" ry="3" fill="#2C2C28" stroke="none"/><path d="M78 155l-12 40M130 150l6 46"/><path d="M155 105l24-18"/><circle cx="185" cy="82" r="12"/><path d="M158 125c10-2 18-10 16-22"/></svg>',
    'head-tilt': '<svg viewBox="0 0 240 240" fill="none" stroke="#6B8F71" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><ellipse cx="120" cy="155" rx="50" ry="35"/><circle cx="120" cy="88" r="32" transform="rotate(-15 120 88)"/><path d="M92 64c-8-16-5-30 4-33s17 8 16 22"/><path d="M140 72c8-14 6-28-3-31s-16 7-16 20"/><circle cx="106" cy="82" r="4" fill="#2C2C28" stroke="none"/><circle cx="130" cy="78" r="4" fill="#2C2C28" stroke="none"/><ellipse cx="118" cy="94" rx="5" ry="3.5" fill="#2C2C28" stroke="none"/><path d="M100 180v28M140 180v28"/><path d="M168 148c12-4 22-14 18-28"/></svg>',
    jumping: '<svg viewBox="0 0 240 240" fill="none" stroke="#6B8F71" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><ellipse cx="120" cy="110" rx="48" ry="28"/><circle cx="120" cy="56" r="28"/><path d="M99 38c-5-15-1-26 6-28s13 8 11 20"/><path d="M141 38c5-15 1-26-6-28s-13 8-11 20"/><circle cx="110" cy="52" r="3.5" fill="#2C2C28" stroke="none"/><circle cx="130" cy="52" r="3.5" fill="#2C2C28" stroke="none"/><ellipse cx="120" cy="63" rx="4.5" ry="3" fill="#2C2C28" stroke="none"/><path d="M90 132l-14 30M110 135l-4 32M130 135l4 32M150 132l14 30"/><path d="M166 105c10-3 18-12 15-24"/><path d="M40 200h160" stroke-dasharray="6 5" opacity="0.4"/></svg>'
  };

  // Underscore aliases for pose SVGs
  POSE_SVGS['lying_down'] = POSE_SVGS['lying-down'] || POSE_SVGS['lying_down'] || '';
  POSE_SVGS['head_tilt_bow'] = POSE_SVGS['head-tilt'] || POSE_SVGS['head_tilt_bow'] || '';
  POSE_SVGS['play_bow'] = POSE_SVGS['playing'] || POSE_SVGS['play_bow'] || '';
  POSE_SVGS['resting'] = POSE_SVGS['lying_down'] || '';
  var poseScriptEl = document.currentScript || document.querySelector('script[src*="pawkraft-flow.js"]');
  var poseAssetBase = poseScriptEl && poseScriptEl.src ? poseScriptEl.src.replace(/pawkraft-flow\.js(?:\?.*)?$/, '') : '';
  var POSE_IMAGES = {
    standing: 'pose-standing.png',
    sitting: 'pose-sitting.png',
    play_bow: 'pose-play_bow.png',
    lying_down: 'pose-lying_down.png',
    resting: 'pose-resting.png',
    head_tilt_bow: 'pose-head_tilt_bow.png'
  };
  var POSE_THUMB_IMAGES = {
    standing: 'pose-thumb-standing-v2.png',
    sitting: 'pose-thumb-sitting-v2.png',
    play_bow: 'pose-thumb-play_bow-v2.png',
    lying_down: 'pose-thumb-lying_down-v2.png',
    resting: 'pose-thumb-resting-v2.png',
    head_tilt_bow: 'pose-thumb-head_tilt_bow-v2.png'
  };

  function setPoseGraphic(el, pose) {
    if (!el) return;
    var isThumb = el.classList && el.classList.contains('pk-flow__pose-thumb-img');
    var imageName = isThumb ? POSE_THUMB_IMAGES[pose] : POSE_IMAGES[pose];
    if (imageName && poseAssetBase) {
      var opt = getPoseOption(pose);
      var label = (opt ? opt.t : capitalize(pose || 'pet')).replace(/"/g, '&quot;');
      el.innerHTML = '<img class="pk-flow__pose-render" src="' + poseAssetBase + imageName + '" alt="' + label + ' pose" loading="lazy" decoding="async">';
    } else if (POSE_SVGS[pose]) {
      el.innerHTML = POSE_SVGS[pose];
    }
  }
  var POSE_OPTIONS = [
    { v: 'standing', t: 'Classic', d: 'Standing tall, tongue out \u2014 shows off their full profile' },
    { v: 'sitting', t: 'Alert', d: 'Sitting upright, ears perked \u2014 ready for anything' },
    { v: 'play_bow', t: 'Playful', d: 'Play bow, tail up \u2014 ready for fun' },
    { v: 'lying_down', t: 'Relaxed', d: 'Lying down, head up \u2014 calm and content' },
    { v: 'resting', t: 'Sleepy', d: 'Resting with a soft, cozy posture' },
    { v: 'head_tilt_bow', t: 'Curious', d: 'Play bow with a head tilt \u2014 the classic curious look' }
  ];

  var POSE_DESCRIPTIONS = {
    standing: 'Standing tall, tongue out \u2014 shows off their full profile',
    sitting: 'Sitting upright, ears perked \u2014 ready for anything',
    play_bow: 'Play bow, tail up \u2014 ready for fun',
    lying_down: 'Lying down, head up \u2014 calm and content',
    resting: 'Resting with a soft, cozy posture',
    head_tilt_bow: 'Play bow with a head tilt \u2014 the classic curious look'
  };

  // --- Helpers ---
  function $(s) { return document.querySelector(s); }
  function $$(s) { return document.querySelectorAll(s); }

  function generateUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }

  function capitalize(s) { return s ? s.replace(/-/g, ' ').replace(/^./, function(c) { return c.toUpperCase(); }) : ''; }

  function escapeHTML(s) {
    if (!s) return '';
    var d = document.createElement('div');
    d.appendChild(document.createTextNode(s));
    return d.innerHTML;
  }

  function getPoseOption(pose) {
    for (var i = 0; i < POSE_OPTIONS.length; i++) {
      if (POSE_OPTIONS[i].v === pose) return POSE_OPTIONS[i];
    }
    return null;
  }

  function defaultPose() {
    return POSE_OPTIONS[0] ? POSE_OPTIONS[0].v : 'standing';
  }

  function ensurePoseForPet(petNum) {
    var key = 'pet' + petNum + 'Pose';
    if (!getPoseOption(state[key])) {
      state[key] = defaultPose();
    }
    var input = $('[data-pet-pose="' + petNum + '"]');
    if (input) input.value = state[key];
    return state[key];
  }

  function poseLabel(petNum, pose) {
    var option = getPoseOption(pose);
    return option ? option.t : capitalize(pose || '');
  }

  function photoKey(petNum) {
    return 'pet' + petNum;
  }

  function requiredPetNumbers() {
    if (manualMode) return manualRequiredPets.slice();
    if (state.kit === 'duo' && !state.pet2SamePet) return [1, 2];
    return [1];
  }

  function uploadCountsForPet(petNum) {
    var photos = state.photos[photoKey(petNum)] || [];
    var counts = { total: photos.length, uploaded: 0, uploading: 0, failed: 0 };
    photos.forEach(function (photo) {
      if (photo.status === 'uploaded') counts.uploaded += 1;
      else if (photo.status === 'failed') counts.failed += 1;
      else counts.uploading += 1;
    });
    return counts;
  }

  function failedPhotosForPet(petNum) {
    return (state.photos[photoKey(petNum)] || []).filter(function (photo) {
      return photo.status === 'failed';
    });
  }

  function uploadsReady() {
    var pets = requiredPetNumbers();
    for (var i = 0; i < pets.length; i++) {
      var counts = uploadCountsForPet(pets[i]);
      if (counts.total < MIN_PHOTOS) return false;
      if (counts.failed > 0) return false;
      if (counts.uploaded !== counts.total) return false;
    }
    return true;
  }

    function uploadStatusMessage() {
    var parts = [];
    requiredPetNumbers().forEach(function (petNum) {
      var counts = uploadCountsForPet(petNum);
      var failed = failedPhotosForPet(petNum);
      var label = state.kit === 'duo' || manualMode ? (state[photoKey(petNum) + 'Name'] || 'Pet ' + petNum) : 'your pet';
      if (counts.failed > 0) {
        var reason = failed[0] && failed[0].error ? ': ' + failed[0].error : '';
        parts.push(counts.failed + ' upload' + (counts.failed !== 1 ? 's' : '') + ' failed for ' + label + reason);
      } else if (counts.total < MIN_PHOTOS) {
        var needed = MIN_PHOTOS - counts.total;
        parts.push(needed + ' more photo' + (needed !== 1 ? 's' : '') + ' needed for ' + label);
      } else if (counts.uploaded !== counts.total) {
        parts.push('Uploading ' + (counts.total - counts.uploaded) + ' photo' + ((counts.total - counts.uploaded) !== 1 ? 's' : '') + ' for ' + label);
      }
    });
    return parts.join(' | ');
  }

  function selectedUploadedPathnames(petNum) {
    var photos = state.photos[photoKey(petNum)] || [];
    return photos
      .filter(function (photo) { return photo.status === 'uploaded' && photo.pathname; })
      .map(function (photo) { return photo.pathname; });
  }

  function hasPhotoPathname(petNum, pathname) {
    if (!pathname) return false;
    return (state.photos[photoKey(petNum)] || []).some(function (photo) {
      return photo.pathname === pathname;
    });
  }

  function mergeExistingUploads(petNum, photos) {
    if (!Array.isArray(photos) || photos.length === 0) return false;
    var key = photoKey(petNum);
    if (!state.photos[key]) state.photos[key] = [];
    var changed = false;
    photos.forEach(function (photo) {
      var pathname = photo && photo.pathname;
      if (!pathname || hasPhotoPathname(petNum, pathname)) return;
      state.photos[key].push({
        id: generateUUID(),
        name: photo.name || '',
        dataUrl: '',
        status: 'uploaded',
        pathname: pathname,
        error: '',
        removed: false,
        restored: true
      });
      changed = true;
    });
    return changed;
  }

  function hydrateExistingUploads() {
    if (!uploadApiUrl) return Promise.resolve();
    return Promise.all(requiredPetNumbers().map(function (petNum) {
      var sid = sessionIds[photoKey(petNum)];
      if (!sid) return Promise.resolve();
      var url = uploadApiUrl + '/api/photos?sessionId=' + encodeURIComponent(sid);
      return fetch(url).then(function (r) {
        if (!r.ok) throw new Error('Could not load existing uploads: ' + r.status);
        return r.json();
      }).then(function (data) {
        var photos = data && data.photos && data.photos[photoKey(petNum)] ? data.photos[photoKey(petNum)] : [];
        if (mergeExistingUploads(petNum, photos)) {
          renderThumbnails(petNum);
          updateContinueBtn();
          saveState();
        }
      }).catch(function (err) {
        console.warn('Could not hydrate existing uploads:', err);
      });
    }));
  }

  function hydrateManualSubmissionState() {
    if (!manualMode || !uploadApiUrl || !sessionIds.pet1) return Promise.resolve();
    var url = uploadApiUrl + '/api/order?sessionId=' + encodeURIComponent(sessionIds.pet1);
    return fetch(url).then(function (r) {
      if (!r.ok) throw new Error('Could not load order state: ' + r.status);
      return r.json();
    }).then(function (data) {
      var order = data && data.order;
      manualSubmitted = !!(order && order.photo_selection);
      renderThumbnails(1);
      renderThumbnails(2);
      updateContinueBtn();
    }).catch(function (err) {
      console.warn('Could not hydrate manual submission state:', err);
      manualSubmitted = false;
      renderThumbnails(1);
      renderThumbnails(2);
      updateContinueBtn();
    });
  }
  function deleteUploadedPhoto(pathname, sessionId) {
    if (manualMode && manualSubmitted) return Promise.resolve();
    if (!uploadApiUrl || !pathname || !sessionId) return Promise.resolve();
    var url = uploadApiUrl + '/api/delete-upload?sessionId=' + encodeURIComponent(sessionId)
      + '&pathname=' + encodeURIComponent(pathname);
    return fetch(url, { method: 'POST' }).then(function (r) {
      if (!r.ok) throw new Error('Delete failed: ' + r.status);
      return r.json();
    }).catch(function (err) {
      console.warn('Could not delete removed upload:', err);
    });
  }

  function submitPhotoSelections() {
    var sessionId = sessionIds.pet1;
    if (!uploadApiUrl || !sessionId) return Promise.resolve();
    var selections = requiredPetNumbers().map(function (petNum) {
      return {
        petNum: String(petNum),
        pathnames: selectedUploadedPathnames(petNum)
      };
    }).filter(function (selection) {
      return selection.pathnames.length > 0;
    });
    if (selections.length === 0) return Promise.resolve();
    return fetch(uploadApiUrl + '/api/photo-selection', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        sessionId: sessionId,
        selections: selections
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('Photo submit failed: ' + r.status);
      return r.json();
    });
  }

  function resetFlowState() {
    state.kit = 'single';
    state.pet1Name = '';
    state.pet1Breed = '';
    state.pet1Sex = '';
    state.pet1Pose = defaultPose();
    state.pet2Name = '';
    state.pet2Breed = '';
    state.pet2Sex = '';
    state.pet2Pose = defaultPose();
    state.pet2SamePet = true;
    state.photos = { pet1: [], pet2: [] };
    state.photosDeferred = false;
    state.currentStep = 1;
    sessionIds.pet1 = null;
    sessionIds.pet2 = null;
    manualSubmitted = false;
  }

  function clearSavedFlowState() {
    try { localStorage.removeItem(LS_KEY); } catch (e) {}
  }


  function isStoredStateStale(savedState) {
    if (!savedState || typeof savedState !== 'object') return true;
    // Older saved sessions predate checkout cleanup and can resurrect completed orders.
    if (savedState.flowVersion !== STATE_VERSION) return true;
    if (savedState.savedAt && Date.now() - savedState.savedAt > SAVED_STATE_MAX_AGE_MS) return true;
    return false;
  }

  function markCheckoutStarted() {
    try { sessionStorage.setItem(CHECKOUT_STARTED_KEY, '1'); } catch (e) {}
  }

  function clearCheckoutStarted() {
    try { sessionStorage.removeItem(CHECKOUT_STARTED_KEY); } catch (e) {}
  }

  function wasCheckoutStarted() {
    try { return sessionStorage.getItem(CHECKOUT_STARTED_KEY) === '1'; } catch (e) { return false; }
  }

  function resetAfterCartAdd() {
    markCheckoutStarted();
    clearSavedFlowState();
    resetFlowState();
  }
  // --- State Persistence ---
  function ensureUploadSessions() {
    if (!state.photos.pet1) state.photos.pet1 = [];
    if (!state.photos.pet2) state.photos.pet2 = [];
    if (!sessionIds.pet1) sessionIds.pet1 = generateUUID();
    if (state.kit === 'duo') {
      // Duo is one order/session with pet1/ and pet2/ subfolders, not two order folders.
      sessionIds.pet2 = sessionIds.pet1;
    } else {
      sessionIds.pet2 = null;
      state.photos.pet2 = [];
    }
  }

    function saveState() {
    try {
      var o = {};
      ['kit','pet1Name','pet1Breed','pet1Sex','pet1Pose','pet2Name','pet2Breed','pet2Sex','pet2Pose','pet2SamePet'].forEach(function (k) {
        o[k] = state[k];
      });
      o.flowVersion = STATE_VERSION;
      o.savedAt = Date.now();
      // Uploaded photos are not a durable draft until checkout creates the order.
      o.photosDeferred = false;
      o.currentStep = 1;
      o.sessionIds = { pet1: null, pet2: null };
      o.photos = { pet1: [], pet2: [] };
      localStorage.setItem(LS_KEY, JSON.stringify(o));
    } catch (e) {}
  }
  function requestedKitFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      var kit = params.get('kit');
      return kit === 'duo' || kit === 'single' ? kit : '';
    } catch (e) {
      return '';
    }
  }

  function applyRequestedKitFromUrl() {
    var requestedKit = requestedKitFromUrl();
    if (!requestedKit) return;
    state.kit = requestedKit;
    state.currentStep = 1;
    state.photosDeferred = false;
    sessionIds.pet1 = null;
    sessionIds.pet2 = null;
    state.photos = { pet1: [], pet2: [] };
  }

    function loadState() {
    try {
      var raw = localStorage.getItem(LS_KEY);
      if (!raw) return;
      var s = JSON.parse(raw);
      if (isStoredStateStale(s)) {
        clearSavedFlowState();
        return;
      }
      ['kit','pet1Name','pet1Breed','pet1Sex','pet1Pose','pet2Name','pet2Breed','pet2Sex','pet2Pose','pet2SamePet'].forEach(function (k) {
        if (s[k] !== undefined) state[k] = s[k];
      });
      state.photosDeferred = false;
      state.currentStep = 1;
      sessionIds.pet1 = null;
      sessionIds.pet2 = null;
      state.photos = { pet1: [], pet2: [] };
    } catch (e) {}
  }

  // --- Price ---
  function total() {
    return state.kit === 'single' ? PRICE_LABELS.single : PRICE_LABELS.duo;
  }

  function updatePrice() {
    $$('[data-total-amount]').forEach(function (el) { el.textContent = total(); });
  }

  // --- Pose Graphic ---
  function updatePoseGraphic() {
    var pose = state.pet1Pose || defaultPose();
    var container = $('[data-pose-graphic]');
    setPoseGraphic(container, pose);
    var previewSelect = $('[data-preview-pose-select]');
    if (previewSelect) previewSelect.value = pose;
    updateBackCard();
    updateCardNames();
  }

  function updateCardsHand() {
    var hand = $('[data-cards-hand]');
    if (hand) {
      hand.classList.toggle('pk-flow__cards-hand--duo', state.kit === 'duo');
      var front = $('[data-pose-card-front]');
      var back = $('[data-pose-card-back]');
      if (front) front.classList.remove('pk-flow__pose-card--on-top');
      if (back) back.classList.remove('pk-flow__pose-card--on-top');
    }
    updateBackCard();
  }

  // Track which pet's card is on top (for preview dropdown sync)
  var activeCardPet = 1;

  function initCardSwap() {
    var front = $('[data-pose-card-front]');
    var back = $('[data-pose-card-back]');
    if (!front || !back) return;

    function bringToFront(card, other) {
      if (state.kit !== 'duo') return;
      other.classList.remove('pk-flow__pose-card--on-top');
      card.classList.remove('pk-flow__pose-card--on-top');
      void card.offsetWidth; // force reflow
      card.classList.add('pk-flow__pose-card--on-top');
      var isFront = card === front;
      activeCardPet = isFront ? 1 : 2;
      var previewSelect = $('[data-preview-pose-select]');
      if (previewSelect) {
        previewSelect.value = isFront ? (state.pet1Pose || defaultPose()) : (state.pet2Pose || state.pet1Pose || defaultPose());
      }
    }

    front.addEventListener('click', function () { bringToFront(front, back); });
    back.addEventListener('click', function () { bringToFront(back, front); });
  }

  function initPreviewPoseSelect() {
    var sel = $('[data-preview-pose-select]');
    if (!sel) return;
    sel.addEventListener('change', function () {
      var val = this.value;
      if (!val) return;
      // Determine which pet this applies to
      var petNum = (state.kit === 'duo') ? activeCardPet : 1;
      if (petNum === 1) {
        state.pet1Pose = val;
        var pose1 = $('[data-pet-pose="1"]');
        if (pose1) pose1.value = val;
        updatePoseGraphic();
      } else {
        state.pet2Pose = val;
        var pose2 = $('[data-pet-pose="2"]');
        if (pose2) pose2.value = val;
        updateBackCard();
      }
      saveState();
    });
  }

  function updateBackCard() {
    var back = $('[data-pose-graphic-back]');
    if (!back) return;
    if (state.kit === 'duo') {
      var pose2 = state.pet2Pose || state.pet1Pose || defaultPose();
      setPoseGraphic(back, pose2);
    }
  }

  function updateCardNames() {
    var name1El = $('[data-card-pet-name="1"]');
    var name2El = $('[data-card-pet-name="2"]');
    if (name1El) name1El.textContent = state.pet1Name || 'Pet 1';
    if (name2El) name2El.textContent = state.pet2Name || 'Pet 2';
  }

  function updateKitCopy() {
    var contents = $('[data-kit-contents]');
    if (contents) {
      var copyAttr = state.kit === 'duo' ? 'data-duo-contents' : 'data-single-contents';
      var copy = contents.getAttribute(copyAttr);
      if (copy) contents.textContent = copy;
    }
    var duoNote = $('[data-duo-note]');
    if (duoNote) duoNote.style.display = state.kit === 'duo' ? 'block' : 'none';
  }

  // --- Kit Toggle ---
  function initKitToggle() {
    $$('[data-kit]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.kit = this.getAttribute('data-kit');
        $$('[data-kit]').forEach(function (b) { b.classList.remove('pk-flow__pill-btn--active'); });
        this.classList.add('pk-flow__pill-btn--active');

        var pet2 = $('[data-pet-section="2"]');
        if (pet2) {
          if (state.kit === 'duo') pet2.classList.remove('pk-flow__section--hidden');
          else pet2.classList.add('pk-flow__section--hidden');
        }
        updateKitCopy();

        if (state.kit === 'duo') syncPet2Pose();
        ensurePoseForPet(1);
        ensurePoseForPet(2);
        updateCardsHand();
        updatePrice();
        saveState();
      });
    });
  }

  // --- Pet Inputs ---
  function initPetInputs() {
    var map = [
      { sel: '[data-pet-name="1"]', key: 'pet1Name', mirror: 'pet2Name' },
      { sel: '[data-pet-breed="1"]', key: 'pet1Breed', mirror: 'pet2Breed' },
      { sel: '[data-pet-sex="1"]', key: 'pet1Sex', mirror: 'pet2Sex' },
      { sel: '[data-pet-name="2"]', key: 'pet2Name' },
      { sel: '[data-pet-breed="2"]', key: 'pet2Breed' },
      { sel: '[data-pet-sex="2"]', key: 'pet2Sex' }
    ];
    map.forEach(function (m) {
      var el = $(m.sel);
      if (!el) return;
      var handler = function () {
        state[m.key] = this.value;
        if (m.mirror && state.pet2SamePet) state[m.mirror] = this.value;
        if (m.key === 'pet1Name' || m.key === 'pet2Name') updateCardNames();
        saveState();
      };
      el.addEventListener('input', handler);
      if (el.tagName === 'SELECT') el.addEventListener('change', handler);
    });
  }

  // --- Same Pet Checkbox ---
  function updateSamePetUI() {
    var nameField = $('[data-pet2-name-field]');
    var breedRow = $('[data-pet2-breed-row]');
    var sexField = $('[data-pet2-sex-field]');
    if (nameField) nameField.classList.toggle('pk-flow__field--hidden', state.pet2SamePet);
    if (breedRow) breedRow.classList.toggle('pk-flow__row--hidden', state.pet2SamePet);
    if (sexField) sexField.classList.toggle('pk-flow__field--hidden', state.pet2SamePet);

    if (state.pet2SamePet) {
      state.pet2Name = state.pet1Name;
      state.pet2Breed = state.pet1Breed;
      state.pet2Sex = state.pet1Sex;
    }
  }

  function syncPet2Pose() {
    var pose2 = $('[data-pet-pose="2"]');
    if (pose2 && state.pet1Pose) {
      state.pet2Pose = state.pet1Pose;
      pose2.value = state.pet1Pose;
    }
  }

  function initSamePet() {
    var check = $('[data-same-pet-check]');
    if (!check) return;
    check.addEventListener('change', function () {
      state.pet2SamePet = this.checked;
      updateSamePetUI();
      saveState();
    });
  }

  // --- Pose Dropdowns ---
  function initPoseDropdowns() {
    var pose1 = $('[data-pet-pose="1"]');
    var pose2 = $('[data-pet-pose="2"]');

    if (pose1) {
      pose1.addEventListener('change', function () {
        state.pet1Pose = this.value;
        updatePoseGraphic();
        saveState();
      });
    }
    if (pose2) {
      pose2.addEventListener('change', function () {
        state.pet2Pose = this.value;
        updateBackCard();
        if (activeCardPet === 2) {
          var previewSelect = $('[data-preview-pose-select]');
          if (previewSelect) previewSelect.value = this.value;
        }
        saveState();
      });
    }
  }
  // --- Navigation ---
    function showStep(n) {
    $$('.pk-flow__step').forEach(function (s) { s.classList.remove('pk-flow__step--active'); });
    var target = $('[data-step="' + n + '"]');
    if (target) target.classList.add('pk-flow__step--active');

    $$('[data-progress-step]').forEach(function (ps) {
      var num = parseInt(ps.getAttribute('data-progress-step'), 10);
      ps.classList.remove('pk-flow__progress-step--active', 'pk-flow__progress-step--completed');
      if (num === n) ps.classList.add('pk-flow__progress-step--active');
      else if (num < n) ps.classList.add('pk-flow__progress-step--completed');
    });
    $$('[data-progress-line]').forEach(function (l) {
      var num = parseInt(l.getAttribute('data-progress-line'), 10);
      l.classList.toggle('pk-flow__progress-line--active', num < n);
    });
  }

  function goToStep(n) {
    showStep(n);
    state.currentStep = n;
    if (n === 2) {
      ensureUploadSessions();
      populateInlineSummary();
      updatePhotoStep();
      hydrateExistingUploads();
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
    saveState();
  }

  function flashError(el) {
    if (!el) return;
    el.style.borderColor = '#e53e3e';
    setTimeout(function () { el.style.borderColor = ''; }, 2000);
  }

  function validateStep1() {
    var ok = true;
    ensurePoseForPet(1);
    ensurePoseForPet(2);
    if (!state.pet1Name.trim()) { flashError($('[data-pet-name="1"]')); ok = false; }
    if (!state.pet1Pose) { flashError($('[data-pet-pose="1"]')); ok = false; }
    if (state.kit === 'duo') {
      if (!state.pet2SamePet && !state.pet2Name.trim()) { flashError($('[data-pet-name="2"]')); ok = false; }
      if (!state.pet2Pose) { flashError($('[data-pet-pose="2"]')); ok = false; }
    }
    return ok;
  }

  function initNavigation() {
        var cont2 = $('[data-continue-to="2"]');
    if (cont2) cont2.addEventListener('click', function (e) {
      e.preventDefault();
      if (!validateStep1()) return;
      state.photosDeferred = true;
      saveState();
      doCheckout(cont2);
    });
    var skip = $('[data-skip-photos]');
    if (skip) skip.addEventListener('click', function (e) {
      e.preventDefault();
      state.photosDeferred = true;
      saveState();
      doCheckout(skip);
    });

    $$('[data-back-to="1"]').forEach(function (back) {
      back.addEventListener('click', function (e) { e.preventDefault(); goToStep(1); });
    });
  }

  // --- Photo Upload ---
  function updatePhotoStep() {
    var heading = $('[data-upload-heading]');
    var panels = $('[data-upload-panels]');
    var panel1 = $('[data-upload-panel="1"]');
    var panel2 = $('[data-upload-panel="2"]');
    var title1 = $('[data-upload-panel-title="1"]');
    var title2 = $('[data-upload-panel-title="2"]');
    var needsSecondPhotoSet = state.kit === 'duo' && !state.pet2SamePet;

    if (needsSecondPhotoSet) {
      if (heading) heading.textContent = 'Upload photos of your dogs';
      if (panels) panels.classList.add('pk-flow__upload-panels--duo');
      if (panel2) panel2.classList.remove('pk-flow__upload-panel--hidden');
      if (title1) title1.textContent = state.pet1Name || 'Dog 1';
      if (title2) title2.textContent = state.pet2Name || 'Dog 2';
    } else {
      if (heading) heading.textContent = 'Upload photos of ' + (state.pet1Name || 'your dog');
      if (panels) panels.classList.remove('pk-flow__upload-panels--duo');
      if (panel2) panel2.classList.add('pk-flow__upload-panel--hidden');
      if (title1) title1.textContent = state.pet1Name || 'Your dog';
    }
    renderThumbnails(1);
    renderThumbnails(2);
    updateContinueBtn();
  }

    function uploadedPhotoPreviewDataUrl() {
    return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 120">' +
      '<rect width="160" height="120" rx="14" fill="#edf4ee"/>' +
      '<path d="M49 63l21 21 43-50" fill="none" stroke="#6b8f71" stroke-width="9" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<text x="80" y="103" text-anchor="middle" font-family="Arial" font-size="12" fill="#526f57">Uploaded</text>' +
      '</svg>'
    );
  }

  function photoPreviewDataUrl(photo) {
    if (photo && photo.dataUrl) return photo.dataUrl;
    if (photo && photo.status === 'uploaded') return uploadedPhotoPreviewDataUrl();
    return failedUploadPreviewDataUrl();
  }

  function renderThumbnails(petNum) {
    var selector = manualMode ? '[data-manual-thumbnails="' + petNum + '"]' : '[data-thumbnails="' + petNum + '"]';
    var c = $(selector);
    if (!c) return;
    c.innerHTML = '';
    var key = 'pet' + petNum;
    (state.photos[key] || []).forEach(function (photo, i) {
      var d = document.createElement('div');
      d.className = 'pk-flow__thumbnail pk-flow__thumbnail--' + (photo.status || 'uploading');
      if (photo.error) d.title = photo.error;
      var img = document.createElement('img');
      img.src = photoPreviewDataUrl(photo);
      img.alt = 'Photo ' + (i + 1);
      d.appendChild(img);
      var badge = document.createElement('span');
      badge.className = 'pk-flow__thumbnail-status';
      badge.textContent = photo.status === 'uploaded' ? 'Uploaded' : (photo.status === 'failed' ? failedUploadLabel(photo.error) : 'Uploading');
      d.appendChild(badge);
      if (!(manualMode && manualSubmitted)) {
        var x = document.createElement('button');
        x.type = 'button';
        x.className = 'pk-flow__thumbnail-remove';
        x.textContent = '\u00D7';
        x.addEventListener('click', function (e) {
          e.stopPropagation();
          removePhoto(petNum, i);
        });
        d.appendChild(x);
      }
      c.appendChild(d);
    });
  }

  function removePhoto(petNum, index) {
    var key = 'pet' + petNum;
    var photo = state.photos[key] && state.photos[key][index];
    if (!photo) return;
    if (manualMode && manualSubmitted) return;
    photo.removed = true;
    state.photos[key].splice(index, 1);

    if (photo.pathname) {
      deleteUploadedPhoto(photo.pathname, sessionIds[key] || sessionIds.pet1);
    }

    renderThumbnails(petNum);
    updateContinueBtn();
    saveState();
  }

  function updateContinueBtn() {
    var btn = manualMode ? $('[data-manual-submit]') : $('[data-place-order]');
    if (!btn) return;
    var ready = uploadsReady();
    var disabled = !ready || (manualMode && manualSubmitted);
    btn.disabled = disabled;
    btn.classList.toggle('pk-flow__place-order-btn--disabled', disabled);
    if (manualMode) {
      btn.textContent = manualSubmitted ? 'Submitted' : 'Submit photos';
    }

    // Update photo status text
    var status = manualMode ? $('[data-manual-status]') : $('[data-photo-status]');
    if (status) {
      if (manualMode && manualSubmitted) {
        status.textContent = "You're all set. We've received your photos.";
        status.className = 'pk-flow__photo-status pk-flow__photo-status--ready';
      } else if (ready) {
        status.textContent = manualMode ? "All photos are uploaded. Submit when you're done." : "Thanks, we've got your photos!";
        status.className = 'pk-flow__photo-status pk-flow__photo-status--ready';
      } else {
        var parts = [uploadStatusMessage()];
        status.textContent = parts.join(' | ');
        status.className = 'pk-flow__photo-status pk-flow__photo-status--needed';
      }
    }
  }

  function isHeic(file) {
    if (file.type === 'image/heic' || file.type === 'image/heif') return true;
    var name = (file.name || '').toLowerCase();
    return name.endsWith('.heic') || name.endsWith('.heif');
  }

  function failedUploadLabel(error) {
    if (!error) return 'Failed';
    if (/too large|size|resize/i.test(error)) return 'Too large';
    if (/type|image|heic|convert/i.test(error)) return 'Invalid';
    return 'Failed';
  }

  function failedUploadPreviewDataUrl() {
    return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 120">' +
      '<rect width="160" height="120" rx="14" fill="#f3eee7"/>' +
      '<path d="M50 76h60M80 38v42" stroke="#9b6b58" stroke-width="8" stroke-linecap="round"/>' +
      '<text x="80" y="101" text-anchor="middle" font-family="Arial" font-size="12" fill="#7b6f65">Upload failed</text>' +
      '</svg>'
    );
  }

  function readBlobAsDataUrl(blob) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function (e) { resolve(e.target.result); };
      reader.onerror = function () { reject(new Error('Could not read image preview')); };
      reader.readAsDataURL(blob);
    });
  }

  function loadImageFromBlob(blob) {
    return new Promise(function (resolve, reject) {
      var url = URL.createObjectURL(blob);
      var img = new Image();
      img.onload = function () {
        URL.revokeObjectURL(url);
        resolve(img);
      };
      img.onerror = function () {
        URL.revokeObjectURL(url);
        reject(new Error('Could not read image for resizing'));
      };
      img.src = url;
    });
  }

  function canvasToBlob(canvas, type, quality) {
    return new Promise(function (resolve, reject) {
      canvas.toBlob(function (blob) {
        if (!blob) reject(new Error('Could not resize image'));
        else resolve(blob);
      }, type, quality);
    });
  }

  function blobToNamedFile(blob, originalName) {
    var base = (originalName || 'photo').replace(/\.[^.]+$/, '') || 'photo';
    var name = base + '.jpg';
    try {
      return new File([blob], name, { type: 'image/jpeg', lastModified: Date.now() });
    } catch (e) {
      blob.name = name;
      return blob;
    }
  }

  function resizeImageBlob(blob, originalName) {
    return loadImageFromBlob(blob).then(function (img) {
      var originalWidth = img.naturalWidth || img.width;
      var originalHeight = img.naturalHeight || img.height;
      if (!originalWidth || !originalHeight) throw new Error('Could not read image dimensions');

      var dimensionSteps = [MAX_UPLOAD_DIMENSION, 2600, 2200, 1800, 1500];
      var qualitySteps = [0.9, 0.84, 0.78, 0.72, 0.66, 0.6];
      var attempt = Promise.resolve(null);

      dimensionSteps.forEach(function (maxDimension) {
        qualitySteps.forEach(function (quality) {
          attempt = attempt.then(function (result) {
            if (result && result.size <= TARGET_UPLOAD_BYTES) return result;
            var scale = Math.min(1, maxDimension / Math.max(originalWidth, originalHeight));
            var width = Math.max(1, Math.round(originalWidth * scale));
            var height = Math.max(1, Math.round(originalHeight * scale));
            var canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            var ctx = canvas.getContext('2d', { alpha: false });
            ctx.fillStyle = '#ffffff';
            ctx.fillRect(0, 0, width, height);
            ctx.drawImage(img, 0, 0, width, height);
            return canvasToBlob(canvas, 'image/jpeg', quality);
          });
        });
      });

      return attempt.then(function (result) {
        if (!result || result.size > TARGET_UPLOAD_BYTES) {
          throw new Error('Photo is too large to upload after resizing. Try a smaller image.');
        }
        return blobToNamedFile(result, originalName);
      });
    });
  }

  function preparePhotoForUpload(file) {
    if (!file) return Promise.reject(new Error('No file selected'));
    if (isHeic(file)) {
      if (typeof heic2any === 'undefined') {
        return Promise.reject(new Error('HEIC converter did not load. Please use JPG or PNG.'));
      }
      return heic2any({ blob: file, toType: 'image/jpeg', quality: 0.9 }).then(function (convertedBlob) {
        if (Array.isArray(convertedBlob)) convertedBlob = convertedBlob[0];
        return resizeImageBlob(convertedBlob, file.name || 'photo.heic');
      });
    }
    if (!file.type || !file.type.startsWith('image/')) {
      return Promise.reject(new Error('Please upload image files only.'));
    }
    if (file.size <= TARGET_UPLOAD_BYTES && Math.max(0, file.size) > 0) {
      return Promise.resolve(file);
    }
    return resizeImageBlob(file, file.name || 'photo.jpg');
  }

  function addFailedPhoto(file, message, petNum) {
    var key = 'pet' + petNum;
    if (!state.photos[key]) state.photos[key] = [];
    if (state.photos[key].length >= MAX_PHOTOS) return;
    manualSubmitted = false;
    state.photos[key].push({
      id: generateUUID(),
      file: null,
      dataUrl: failedUploadPreviewDataUrl(),
      status: 'failed',
      pathname: '',
      error: message || 'Upload failed',
      removed: false
    });
    renderThumbnails(petNum);
    updateContinueBtn();
    saveState();
  }

    function addPhoto(file, dataUrl, petNum) {
    var key = 'pet' + petNum;
    if (state.photos[key].length >= MAX_PHOTOS) return;
    manualSubmitted = false;
    var photo = {
      id: generateUUID(),
      file: file,
      name: file.name || '',
      dataUrl: dataUrl,
      status: uploadApiUrl ? 'uploading' : 'failed',
      pathname: '',
      error: uploadApiUrl ? '' : 'Upload service unavailable',
      removed: false
    };
    state.photos[key].push(photo);
    renderThumbnails(petNum);
    updateContinueBtn();
    saveState();

    // Upload the browser-resized image to Vercel Blob and keep checkout disabled until it succeeds.
    var sid = sessionIds['pet' + petNum] || sessionIds.pet1;
    if (uploadApiUrl && sid) {
      var fileName = file.name || ('photo_' + Date.now() + '.jpg');
      var blob = file instanceof Blob ? file : new Blob([file], { type: 'image/jpeg' });
      var url = uploadApiUrl + '/api/upload?sessionId=' + encodeURIComponent(sid)
        + '&petNum=' + petNum + '&fileName=' + encodeURIComponent(fileName);
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': blob.type || 'image/jpeg' },
        body: blob
      }).then(function (r) {
        return r.text().then(function (text) {
          var data = {};
          try { data = text ? JSON.parse(text) : {}; } catch (e) {}
          if (!r.ok) throw new Error(data.error || ('Upload failed: ' + r.status));
          return data;
        });
      }).then(function (data) {
        photo.pathname = data.pathname || '';
        if (photo.removed) {
          return deleteUploadedPhoto(photo.pathname, sid);
        }
        photo.status = 'uploaded';
        photo.error = '';
      }).catch(function (err) {
        console.error('Photo upload error:', err);
        if (photo.removed) return;
        photo.status = 'failed';
        photo.error = err.message || 'Upload failed';
      }).finally(function () {
        if (photo.removed) return;
        renderThumbnails(petNum);
        updateContinueBtn();
        saveState();
      });
    } else if (!sid) {
      photo.status = 'failed';
      photo.error = 'Upload session missing';
      renderThumbnails(petNum);
      updateContinueBtn();
      saveState();
    }
  }

      function processFiles(files, petNum) {
    var key = 'pet' + petNum;
    if (!state.photos[key]) state.photos[key] = [];
    if (!manualMode) ensureUploadSessions();
    Array.prototype.slice.call(files || []).forEach(function (file) {
      if (state.photos[key].length >= MAX_PHOTOS) return;
      preparePhotoForUpload(file).then(function (preparedFile) {
        if (state.photos[key].length >= MAX_PHOTOS) return;
        return readBlobAsDataUrl(preparedFile).then(function (dataUrl) {
          addPhoto(preparedFile, dataUrl, petNum);
        });
      }).catch(function (err) {
        console.error('Photo preparation failed:', err);
        addFailedPhoto(file, err.message || 'Could not prepare photo for upload', petNum);
      });
    });
  }

  function initPhotoUpload() {
    function bind(zone, input, petNum) {
      if (zone) {
        zone.addEventListener('click', function (e) { if (e.target === input) return; if (input) input.click(); });
        zone.addEventListener('dragover', function (e) { e.preventDefault(); this.classList.add('pk-flow__drop-zone--dragover'); });
        zone.addEventListener('dragleave', function (e) { e.preventDefault(); this.classList.remove('pk-flow__drop-zone--dragover'); });
        zone.addEventListener('drop', function (e) { e.preventDefault(); this.classList.remove('pk-flow__drop-zone--dragover'); if (e.dataTransfer && e.dataTransfer.files) processFiles(e.dataTransfer.files, petNum); });
      }
      if (input) input.addEventListener('change', function () { if (this.files) processFiles(this.files, petNum); this.value = ''; });
    }

    [1, 2].forEach(function (petNum) {
      var zone = $('[data-drop-zone="' + petNum + '"]');
      var input = $('[data-file-input="' + petNum + '"]');
      bind(zone, input, petNum);
      bind($('[data-manual-drop-zone="' + petNum + '"]'), $('[data-manual-file-input="' + petNum + '"]'), petNum);
    });
  }

  // --- Inline Summary ---
  function populateInlineSummary() {
    var kitEl = $('[data-summary-kit]');
    var totalEl = $('[data-summary-total]');
    var detailsEl = $('[data-summary-details]');

    if (kitEl) kitEl.textContent = state.kit === 'single' ? 'Single Kit' : 'Duo Kit';
    if (totalEl) totalEl.textContent = total();

    if (detailsEl) {
      var lines = [];
      var pet1 = escapeHTML(state.pet1Name || 'Pet 1');
      if (state.pet1Breed) pet1 += ' (' + escapeHTML(state.pet1Breed) + ')';
      pet1 += ' · ' + capitalize(state.pet1Pose);
      lines.push(pet1);
      if (state.kit === 'duo') {
        var pet2 = escapeHTML(state.pet2Name || 'Pet 2');
        if (state.pet2Breed) pet2 += ' (' + escapeHTML(state.pet2Breed) + ')';
        pet2 += ' · ' + capitalize(state.pet2Pose);
        lines.push(pet2);
      }
      detailsEl.innerHTML = lines.join('<br>');
    }
  }

  // --- Checkout ---
    function doCheckout(triggerBtn) {
    if (!state.photosDeferred && !uploadsReady()) {
      alert('Please wait for your photos to finish uploading before checkout.');
      updateContinueBtn();
      return;
    }

    ensureUploadSessions();
    var btn = triggerBtn || $('[data-place-order]') || $('[data-continue-to="2"]');
    var orig = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Processing...'; }
    var config = flowConfig;
    var vid = state.kit === 'single' ? config.singleVariantId : config.duoVariantId;
    var sid1 = sessionIds.pet1;
    var sid2 = sessionIds.pet2;
    var deferredUploadUrl = manualUploadUrl(sid1, state.kit === 'duo' && !state.pet2SamePet ? sid2 : null);

    if (!vid || Number.isNaN(parseInt(vid, 10))) {
      alert('This product is not ready for checkout yet. Please contact hello@pawkraft.co.');
      if (btn) { btn.disabled = false; btn.innerHTML = orig; }
      return;
    }

    var props = {
      '_pet1_name': state.pet1Name, '_pet1_breed': state.pet1Breed,
      '_pet1_species': 'dog', '_pet1_sex': state.pet1Sex, '_pet1_pose': state.pet1Pose,
      '_photos_deferred': state.photosDeferred ? 'true' : 'false',
      '_pet1_session_id': sid1,
      '_manual_upload_url': deferredUploadUrl
    };
    if (state.photosDeferred) {
      props['Photo upload link'] = 'We will email you a secure upload link after checkout.';
    }
    if (state.kit === 'duo') {
      props['_pet2_name'] = state.pet2Name;
      props['_pet2_breed'] = state.pet2Breed;
      props['_pet2_species'] = 'dog';
      props['_pet2_sex'] = state.pet2Sex;
      props['_pet2_pose'] = state.pet2Pose;
      props['_pet_2_is_same_pet'] = state.pet2SamePet ? 'true' : 'false';
      props['_pet2_session_id'] = sid2;
    }

    var items = [{ id: parseInt(vid, 10), quantity: 1, properties: props }];

    saveState();

    (state.photosDeferred ? Promise.resolve() : submitPhotoSelections())
      .then(function () {
        return fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } });
      })
      .then(function (r) { if (!r.ok) throw new Error('Cart clear error'); return r.json(); })
      .then(function () {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              'Pawkraft upload link': state.photosDeferred ? deferredUploadUrl : '',
              'Pawkraft photos deferred': state.photosDeferred ? 'true' : 'false'
            }
          })
        });
      })
      .then(function (r) { if (!r.ok) throw new Error('Cart attributes error'); return r.json(); })
      .then(function () {
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) });
      })
      .then(function (r) { if (!r.ok) throw new Error('Cart error'); return r.json(); })
      .then(function () { resetAfterCartAdd(); window.location.href = '/checkout'; })
      .catch(function (err) { console.error(err); alert('Something went wrong. Please try again.'); if (btn) { btn.disabled = false; btn.innerHTML = orig; } });
  }

  function initCheckout() {
    var btn = $('[data-place-order]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      state.photosDeferred = false;
      doCheckout(btn);
    });
  }

  function manualUploadUrl(sid1, sid2) {
    var url = new URL('/pages/create-your-kit', window.location.origin);
    url.searchParams.set('upload', 'manual');
    url.searchParams.set('pet1', sid1);
    if (sid2) url.searchParams.set('pet2', sid2);
    if (state.pet1Name) url.searchParams.set('name1', state.pet1Name);
    if (sid2 && state.pet2Name) url.searchParams.set('name2', state.pet2Name);
    return url.toString();
  }

  function initManualUploadMode() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('upload') !== 'manual') return false;

    var pet1Session = params.get('pet1');
    if (!pet1Session) return false;

    manualMode = true;
    sessionIds.pet1 = pet1Session;
    sessionIds.pet2 = params.get('pet2') || null;
    manualRequiredPets = sessionIds.pet2 ? [1, 2] : [1];
    state.photos = { pet1: [], pet2: [] };
    state.pet1Name = params.get('name1') || 'Pet 1';
    state.pet2Name = params.get('name2') || 'Pet 2';
    state.kit = sessionIds.pet2 ? 'duo' : 'single';

    var progress = $('.pk-flow__progress');
    if (progress) progress.style.display = 'none';
    $$('.pk-flow__step').forEach(function (step) { step.style.display = 'none'; });

    var manual = $('[data-manual-upload]');
    if (manual) manual.hidden = false;

    var panels = $('[data-manual-panels]');
    var panel2 = $('[data-manual-panel="2"]');
    var title1 = $('[data-manual-panel-title="1"]');
    var title2 = $('[data-manual-panel-title="2"]');
    if (title1) title1.textContent = state.pet1Name || 'Pet 1';
    if (title2) title2.textContent = state.pet2Name || 'Pet 2';
    if (panels) panels.classList.toggle('pk-flow__upload-panels--duo', !!sessionIds.pet2);
    if (panel2) panel2.classList.toggle('pk-flow__upload-panel--hidden', !sessionIds.pet2);

    renderThumbnails(1);
    renderThumbnails(2);
    updateContinueBtn();
    manualSubmitted = true;
    hydrateManualSubmissionState();
    return true;
  }

  function initManualSubmit() {
    var btn = $('[data-manual-submit]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      if (!uploadsReady()) return;
      btn.disabled = true;
      btn.textContent = 'Submitting...';
      var status = $('[data-manual-status]');
      submitPhotoSelections().then(function () {
        manualSubmitted = true;
        renderThumbnails(1);
        renderThumbnails(2);
        updateContinueBtn();
      }).catch(function (err) {
        console.error(err);
        manualSubmitted = false;
        btn.disabled = false;
        btn.textContent = 'Submit photos';
        if (status) {
          status.textContent = 'Something went wrong submitting your photos. Please try again.';
          status.className = 'pk-flow__photo-status pk-flow__photo-status--needed';
        }
      });
    });
  }

  // --- Restore UI ---
    function restoreUI() {
    ensurePoseForPet(1);
    ensurePoseForPet(2);

    // Kit pill
    $$('[data-kit]').forEach(function (b) { b.classList.toggle('pk-flow__pill-btn--active', b.getAttribute('data-kit') === state.kit); });
    var pet2 = $('[data-pet-section="2"]');
    if (pet2) pet2.classList.toggle('pk-flow__section--hidden', state.kit !== 'duo');
    updateKitCopy();

    // Pet inputs
    [1, 2].forEach(function (n) {
      var nameEl = $('[data-pet-name="' + n + '"]');
      var breedEl = $('[data-pet-breed="' + n + '"]');
      var poseEl = $('[data-pet-pose="' + n + '"]');
      if (nameEl) nameEl.value = state['pet' + n + 'Name'];
      if (breedEl) breedEl.value = state['pet' + n + 'Breed'];
      if (poseEl) poseEl.value = state['pet' + n + 'Pose'];
      $$('[data-pose-pet="' + n + '"]').forEach(function (btn) {
        btn.classList.toggle('pk-flow__pose-thumb--selected', btn.getAttribute('data-pose-value') === state['pet' + n + 'Pose']);
      });
    });

    // Same pet checkbox
    var samePetCheck = $('[data-same-pet-check]');
    if (samePetCheck) samePetCheck.checked = state.pet2SamePet;
    updateSamePetUI();

    updatePrice();
    updatePoseGraphic();
    updateCardsHand();
    updateCardNames();

    if (state.currentStep === 2) {
      ensureUploadSessions();
      populateInlineSummary();
      updatePhotoStep();
      showStep(2);
      hydrateExistingUploads();
      saveState();
    } else {
      showStep(1);
    }
  }

  window.addEventListener('pageshow', function (event) {
    if (manualMode) return;
    if (!wasCheckoutStarted() && !(event.persisted && !localStorage.getItem(LS_KEY))) return;
    clearCheckoutStarted();
    clearSavedFlowState();
    resetFlowState();
    restoreUI();
  });
  // --- Init ---
  function initPoseGrid() {
    // Populate SVG thumbnails
    $$('[data-pose-thumb-graphic]').forEach(function(el) {
      var pose = el.getAttribute('data-pose-thumb-graphic');
      setPoseGraphic(el, pose);
    });

    // Click handlers
    $$('.pk-flow__pose-thumb').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var pose = this.getAttribute('data-pose-value');
        var pet = this.getAttribute('data-pose-pet');
        var grid = this.closest('[data-pose-grid]');

        // Update selection
        grid.querySelectorAll('.pk-flow__pose-thumb').forEach(function(b) {
          b.classList.remove('pk-flow__pose-thumb--selected');
        });
        this.classList.add('pk-flow__pose-thumb--selected');

        // Update hidden input
        var input = $('[data-pet-pose="' + pet + '"]');
        if (input) input.value = pose;

        // Update state
        if (pet === '1') {
          state.pet1Pose = pose;
          updatePoseGraphic();
        } else {
          state.pet2Pose = pose;
          updateBackCard();
        }

        // Update description
        var desc = $('[data-pose-desc="' + pet + '"]');
        if (desc && POSE_DESCRIPTIONS[pose]) {
          desc.style.opacity = '0';
          setTimeout(function() {
            desc.textContent = POSE_DESCRIPTIONS[pose];
            desc.style.opacity = '1';
          }, 150);
        }

        updatePrice();
        saveState();
      });
    });
  }

  function init() {
    try {
      flowConfig = JSON.parse(document.getElementById('pk-flow-config').textContent);
      uploadApiUrl = (flowConfig.uploadApiUrl || '').replace(/\/+$/, '');
      if (flowConfig.prices) {
        PRICE_LABELS.single = flowConfig.prices.single || PRICE_LABELS.single;
        PRICE_LABELS.duo = flowConfig.prices.duo || PRICE_LABELS.duo;
      }
    } catch (e) {}
    if (initManualUploadMode()) {
      initPhotoUpload();
      initManualSubmit();
      hydrateExistingUploads();
      return;
    }
    loadState();
    applyRequestedKitFromUrl();
    initKitToggle();
    initCardSwap();
    initPreviewPoseSelect();
    initPetInputs();
    initSamePet();
    initPoseDropdowns();
    initPoseGrid();
    initNavigation();
    initPhotoUpload();
    initCheckout();
    restoreUI();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
